import {
  Menu,
  Search,
  Settings,
  Moon,
  Sun,
  Monitor,
  Command,
  Plus,
} from 'lucide-react';
import { Button } from '@phrasewright/ui';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  toggleSidebar,
  toggleCommandPalette,
  toggleSettings,
  toggleSearch,
  toggleCreateDialog,
  setTheme,
} from '@/store/slices/uiSlice';
import { ProjectSwitcher } from '@/components/project/ProjectSwitcher';

export function Header() {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.ui.theme);

  const handleThemeToggle = () => {
    const nextTheme =
      theme === 'light' ? 'dark' : theme === 'dark' ? 'system' : 'light';
    dispatch(setTheme(nextTheme));
  };

  const ThemeIcon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;

  return (
    <header className="flex h-12 items-center justify-between border-b px-4">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => dispatch(toggleSidebar())}
          className="h-8 w-8"
        >
          <Menu className="h-4 w-4" />
        </Button>

        <ProjectSwitcher />
      </div>

      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => dispatch(toggleCommandPalette())}
          className="h-8 w-8"
        >
          <Command className="h-4 w-4" />
        </Button>

        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          onClick={() => dispatch(toggleSearch())}
        >
          <Search className="h-4 w-4" />
        </Button>

        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          onClick={() => dispatch(toggleCreateDialog())}
        >
          <Plus className="h-4 w-4" />
        </Button>

        <div className="mx-2 h-4 w-px bg-border" />

        <Button
          variant="ghost"
          size="icon"
          onClick={handleThemeToggle}
          className="h-8 w-8"
        >
          <ThemeIcon className="h-4 w-4" />
        </Button>

        <Button
          variant="ghost"
          size="icon"
          onClick={() => dispatch(toggleSettings())}
          className="h-8 w-8"
        >
          <Settings className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
